/* eslint-disable react/prop-types */
import * as yup from "yup";
import { v4 as uuid } from "uuid";
import { TYPE_FIELD_LIST } from "../../../helper/TypeFieldList";
import { useMemo } from "react";
import { MESSAGE } from "../../../message";

export default function useBrandSchema({ item }) {
  const brandFieldList = useMemo(
    () => [
      {
        id: uuid(),
        name: "manufacturer",
        label: "Nhà sản xuất",
        typeField: TYPE_FIELD_LIST.DYNAMIC_SELECT,
        type: "text",
        defaultValue: "",
        grid: [12],
        path: `/api/v1/manufacturers`,
        params: { limit: 50, skip: 0, sortField: "createdAt", sortOrder: "asc" },
        placeHolder: "Nhà sản xuất",
        required: true,
      },
      {
        id: uuid(),
        name: "name",
        label: "Tên thương hiệu",
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "text",
        defaultValue: "",
        grid: [12],
        placeHolder: MESSAGE.ORIGIN_NAME,
        required: true,
      },
      {
        id: uuid(),
        name: "code",
        label: "Mã thương hiệu",
        typeField: TYPE_FIELD_LIST.TEXTFIELD,
        type: "text",
        defaultValue: "",
        grid: [12],
        placeHolder: "Vd: DRC",
        required: true,
      },
    ],
    [],
  );

  const validationSchema = yup.object().shape({
    manufacturer: yup
      .object({
        _id: yup.string().required("Nhập mã nhà sản xuất"),
      })
      .nullable()
      .transform((value, originalValue) => (originalValue === "" ? null : value))
      .required("Nhập nhà sản xuất"),
    name: yup.string().required("Nhập tên thương hiệu"),
    code: yup.string().required("Nhập mã thương hiệu").min(2, "Ít nhất 2 kí tự").max(10, "Không quá 10 kí tự"),
  });

  const brandObject = {
    manufacturer: item?.manufacturer
      ? {
          ...item.manufacturer,
          id: item.manufacturer._id ?? item.manufacturer.id,
          labelSelect: item.manufacturer.name,
        }
      : undefined,
    name: item?.name ?? undefined,
    code: item?.code ?? undefined,
  };

  return { brandFieldList, validationSchema, brandObject };
}
